module.exports = __webpack_public_path__ + "static/media/07.fdfcfa01.png";